module.exports = __webpack_public_path__ + "static/img/11.d25a262.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/2/eng/11.png
// module id = LVFV
// module chunks = 0